import React, { useState } from 'react';

export default function Step3Email({ data, onNext, onBack, onLoginRedirect }) {
  const [email, setEmail] = useState(data.email || '');
  const [error, setError] = useState('');

  const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleNext = () => {
    if (!isValid) { setError('Entrez une adresse email valide.'); return; }
    onNext({ email });
  };

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <button style={styles.back} onClick={onBack}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span style={styles.stepLabel}>Create Account (3/4)</span>
        <div style={{ width: 36 }} />
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Adresse email</h2>
        <p style={styles.sub}>Vous en aurez besoin pour vous connecter</p>

        <input
          style={styles.input}
          type="email"
          placeholder="exemple@email.com"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError(''); }}
          autoFocus
        />

        {error && <p style={styles.error}>{error}</p>}
      </div>

      <div style={styles.bottom}>
        <button
          style={{ ...styles.btnNext, opacity: !isValid ? 0.5 : 1 }}
          onClick={handleNext}
          disabled={!isValid}
        >
          Next
        </button>
        <button style={styles.loginLink} onClick={onLoginRedirect}>
          I already have an account
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#f5f7ff', display: 'flex', flexDirection: 'column', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px' },
  back: { background: 'none', border: 'none', cursor: 'pointer', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  stepLabel: { color: '#333', fontSize: 15, fontWeight: 600 },
  content: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 24px 20px' },
  title: { fontSize: 26, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 },
  sub: { fontSize: 14, color: '#888', marginBottom: 40, textAlign: 'center' },
  input: { width: '100%', maxWidth: 380, height: 54, background: '#fff', border: '1.5px solid #dde0f0', borderRadius: 14, padding: '0 16px', fontSize: 16, color: '#222', outline: 'none' },
  error: { color: '#e74c3c', fontSize: 13, marginTop: 10 },
  bottom: { padding: '0 24px 40px', display: 'flex', flexDirection: 'column', gap: 14, alignItems: 'center' },
  btnNext: { background: '#3d5ef5', color: '#fff', border: 'none', borderRadius: 14, height: 54, fontSize: 16, fontWeight: 600, cursor: 'pointer', width: '100%', maxWidth: 480 },
  loginLink: { background: 'none', border: 'none', color: '#3d5ef5', fontSize: 14, fontWeight: 500, cursor: 'pointer' },
};
